import { render, staticRenderFns } from "./itemtabs.vue?vue&type=template&id=56ec5642&"
import script from "./itemtabs.vue?vue&type=script&lang=js&"
export * from "./itemtabs.vue?vue&type=script&lang=js&"
import style0 from "./itemtabs.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports